import React, { useCallback } from 'react';
import { Button, FormRow } from '@here/ref-client-ui';
import './gpxTraceFormView.scss';
import { DOMParser } from '@xmldom/xmldom';

function gpxXmlToGeoJSON(xmlString) {
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xmlString, 'application/xml');

  const trkpts = xmlDoc.getElementsByTagName('trkpt');
  const features = [];
  const points = [];


  for (let i = 0; i < trkpts.length; i++) {
    const trkpt = trkpts[i];
    const lat = parseFloat(trkpt.getAttribute('lat'));
    const lon = parseFloat(trkpt.getAttribute('lon'));

    const properties = {};

    // Top-level elements (skip extensions)
    Array.from(trkpt.childNodes)
      .filter(node => node.nodeType === 1 && node.nodeName !== 'extensions')
      .forEach(child => {
        properties[child.nodeName] = child.textContent.trim();
      });

    // Extensions (nested)
    const extensionsNode = Array.from(trkpt.childNodes)
      .find(node => node.nodeType === 1 && node.nodeName === 'extensions');

    if (extensionsNode) {
      const extensions = {};
      Array.from(extensionsNode.childNodes)
        .filter(node => node.nodeType === 1)
        .forEach(extNode => {
          extensions[extNode.nodeName] = extNode.textContent.trim();
        });
      properties.extensions = extensions;
    }

    features.push({
      type: "Feature",
      geometry: { type: "Point", coordinates: [lon, lat, properties.ele || null] },
      properties
    });
    points.push([lon, lat]);
  }

  return {
    gpx: { type: "FeatureCollection", features },
    points
  };
}

function GpxTraceFormView({
  fields: { gpxTrace, gpxPolyline, gpxPolylineSelected },
  setFields,
  setResultState,
}) {
  const getGpxTrace = useCallback(() => {
    try {
      setResultState({
        gpxTrace: gpxTrace,
        gpxPolyline: gpxPolyline,
        gpxPolylineSelected: gpxPolylineSelected,
        activeResultTabId: 1,
        isResultPanelShown: true
      });
    } catch (e) {
      console.error(e);
    }
  }, [gpxTrace, gpxPolyline, setResultState, gpxPolylineSelected]);

  const changeFileGpxTrace = useCallback(
    ({ target }) => {
      const files = target.files;
      const file = files[0];
      if (file) {
        var r = new FileReader();
        r.onload = (e) => {
          const gpxText = e.target.result;
          const { gpx, points } = gpxXmlToGeoJSON(gpxText);
          setFields({ gpxTrace: gpx, gpxPolyline: [{points}], gpxPolylineSelected: 0 });
          setResultState({gpxPolylineSelected: null, gpxPolyline: [], selectedTracePoint: undefined});
        }
        r.readAsText(file);
      } else {
        setFields({ gpxTrace: {}, gpxPolyline: [], gpxPolylineSelected: null });
      }
    },
    [setFields, setResultState]
  );

  return (
    <FormRow className="rf-gpx-trace-form-view">
        <span className="rf-input__caption">GPX Trace (.gpx)</span>
        <span className="rf-input__container">
          <div className="rf-input__field" type="text">
            <input
              className="lui-textfield__seed rf-file-input"
              onChange={changeFileGpxTrace}
              type="file"
              accept=".gpx,application/gpx+xml"
            />
          </div>
        </span>
      <Button title="Show Trace" onClick={getGpxTrace} />
    </FormRow>
  );
}

const gpxTraceFormViewPlugin = {
  parseUrl: () => ({}),
  defaultState: () => ({}),
  getRequestOptions: () => ({}),
  Component: GpxTraceFormView,
};

export default gpxTraceFormViewPlugin;
